import React from 'react';
import Modal from '../../components/Modal';



const FromRegistro = props => (
  <Modal title={props.title} idModal='FromRegistro' isOpen={props.isOpen} closeModal={props.closeModal} modalSize='modal-dialog'>
    <div className='form-group'>
      <div className='row'>
      <div className='col-md-12'>
          <label className='labelInfo' htmlFor='unidadMax'>Descripción de certificado</label>
          <input className='form-control' id='descripcion' onChange={props.onChangeValue} name='descripcion' type='text' value={props.descripcion} />
        </div>
      </div>
    </div>
    <div className='modal-actions'>
      <button className='btn btn-return' onClick={() => props.closeModal()}>Cancelar</button>
      <button className='btn btn-primary pull-right' disabled={props.descripcion.length > 0?false:true} onClick={() => props.createAreaBtn()}>Guardar</button>       
    </div>
  </Modal>
);

FromRegistro.defaultProps = {
  isOpen: false,
};

export default FromRegistro;



// WEBPACK FOOTER //
// ./src/pages/MantAreadeVenta/FromRegistro.js